<template>
  <div id="partners-screen">
    <template v-if="!isLoading">
      <div class="page-action-wrapper">
        <rounded-button
          width="150px"
          height="35px"
          fontSize="14px"
          @click="createNewPartner"
          >{{ $t("partnerScreen.pageAction.newPartner") }}
        </rounded-button>
        <div class="partner-name-filter">
          <basic-input
            height="35px"
            :placeholder="$t('partnersScreen.partnersList.nameFilter')"
            class="qr-filter"
            v-model="partnerName"
          />
        </div>
      </div>
      <div class="partners-list" v-if="filteredPartnerList.length > 0">
        <partners-list
          @getPartners="getPartners"
          :partners="filteredPartnerList"
        />
      </div>
      <template v-else-if="partnerName === undefined || partnerName === ''">
        <div class="empty-state">
          <h5
            class="text"
            v-html="$t('partnersScreen.partnersList.emptyState')"
          ></h5>
        </div>
      </template>
      <template v-else-if="partnerName !== undefined && partnerName !== ''">
        <div class="empty-state">
          <h5
            class="text"
            v-html="$t('partnersScreen.partnersList.noResult')"
          ></h5>
        </div>
      </template>
    </template>
    <template v-if="isLoading">
      <div class="loading-screen">
        <loader-ring />
      </div>
    </template>
  </div>
</template>

<script>
import PartnersModal from "@/components/modules/Partners/PartnersModal";
import PartnersList from "@/components/modules/Partners/PartnersList";
import { mapActions } from "vuex";
export default {
  name: "PartnersScreen",
  props: {},
  components: {
    PartnersList
  },
  data: () => ({
    partners: [],
    partnerName: undefined,
    isLoading: false
  }),
  created() {
    this.getPartners();
  },
  computed: {
    filteredPartnerList() {
      return this.filterPartners();
    }
  },
  methods: {
    ...mapActions({
      readPartners: "partners/readPartners"
    }),
    filterPartners() {
      if (this.partnerName) {
        return this.partners.filter(x => {
          return (x.name + "")
            .toLowerCase()
            .includes(this.partnerName.toLowerCase());
        });
      } else {
        return this.partners;
      }
    },
    createNewPartner() {
      this.$eventBus.showModal({
        title: this.$t("partnersScreen.partnersModal.create.title"),
        bind: {
          is: PartnersModal,
          width: "500px",
          height: "555px"
        },
        on: {
          refreshData: () => {
            this.getPartners();
          }
        }
      });
    },
    getPartners() {
      this.readPartners().then(res => {
        if (res.status === "OK") {
          this.partners = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#partners-screen {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  .loading-screen {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .page-action-wrapper {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .partner-name-filter {
      width: 250px;
    }
  }
}
@media screen and (max-width: 450px) {
  .page-action-wrapper {
    flex-direction: column;
    .partner-name-filter {
      margin-top: 10px;
      // width: 100% !important;
    }
  }
}
</style>
